import React, { useState, useEffect } from 'react'
import { Grid, Row } from 'rsuite'

export default function SearchTagForm({ schema, ...props }) {
  const paragraph = <>&nbsp; &nbsp; &nbsp;</>
  return (
    <Grid>
      <Row style={{ marginBottom: 10 }}>{schema.label}</Row>

      <Row>
        {/* <p>
          {paragraph}
          {schema.value || `ไม่มี${schema.label}`}
        </p> */}
        <div dangerouslySetInnerHTML={{ __html: schema.value || `ไม่มี${schema.label}` }} />
      </Row>
    </Grid>
  )
}
